module.exports = __webpack_public_path__ + "static/images/leaflet-measure/start.png";